import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-admin-edit-document',
  templateUrl: './admin-edit-document.component.html',
  styleUrls: ['./admin-edit-document.component.css']
})
export class AdminEditDocumentComponent implements OnInit {

  constructor(private matdialogref: MatDialogRef<AdminEditDocumentComponent>) { }

  ngOnInit(): void {
  }
  close() {
    this.matdialogref.close();
  }
}
